import React from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { useDrag, useDrop, DropTargetMonitor } from 'react-dnd'
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import PlannerSelect from './PlannerSelect';
import PlannerField from './PlannerField';
import PlannerTextField from './PlannerTextField';
import PlannerLinkFeild from './PlannerLinkFeild';
import PlannerMultipleSelect from './PlannerMultipleSelect';
import { DragItem, ITripPlannerValues } from '../types/locationTypes';
import { getAcuityOptions, getAttendantSeatOptions, getMultiloadAllowedOptions, getMultiloadCapabilityOptions, getStretcherOptions, tooltips,getsharingroleOptions, getServicedByOptions,getPricingByOptions } from './plannerData';
import { XYCoord } from 'dnd-core'
import { ItemTypes } from '../../../common/dndHelper'
import api from "../../../store/api";
import PlannerLinkFeildBy from './PlannerLinkFeildBy';
import PlannerTextFieldPlannername from './PlannerTextFieldPlannername';
import PlannerTextFieldPlannernamestatus from './PlannerTextFieldPlannernamestatus';
import PlannerShiftHours from './PlannerShiftHours';

interface PlannerCardProps {
    parentClasses: ClassNameMap,
    planner: ITripPlannerValues,
    planners: ITripPlannerValues[],
    setPlanners: any,
    setUpdatedPlanners: any,
    index: number,
    moveCard: any,
    sharedlocation:any[]
}

const style = {
    backgroundColor: 'white',
}

const PlannerCard: React.FC<PlannerCardProps> = ({
    parentClasses,
    planner,
    planners,
    setPlanners,
    setUpdatedPlanners,
    index,
    moveCard,
    sharedlocation,
}) => {
    const ref = React.useRef<HTMLDivElement>(null);
    const [{ handlerId }, drop] = useDrop({
        accept: ItemTypes.PLANNER_LOCATION,
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item: DragItem, monitor: DropTargetMonitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = item.index
            const hoverIndex = index

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }

            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()

            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

            // Determine mouse position
            const clientOffset = monitor.getClientOffset()

            // Get pixels to the top
            const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top

            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%

            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }

            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }

            // Time to actually perform the action
            moveCard(dragIndex, hoverIndex)

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    });

    const [{ isDragging }, drag] = useDrag({
        
        type: ItemTypes.PLANNER_LOCATION,
        item: () => {
            return { id: planner.tripPlannerId, index }
        },
        collect: (monitor: any) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const opacity = isDragging ? 0 : 1;
    drag(drop(ref));
    const[plannernamebool,setplannernamebool]=React.useState(false);
    const updatePlanner = (name: string, value: string | null | boolean) => {
        
        const updatedPlanner = { ...planner, [name]: value };
        setUpdatedPlanners(
            planners.map(item => {
                if (item.tripPlannerId === updatedPlanner.tripPlannerId)              
                    return updatedPlanner;
                else
                    return item;
            })
        );
    }

    const deletePlanner = async(id:any)=> {
        setUpdatedPlanners(
            planners.filter(item => item.tripPlannerId !== planner.tripPlannerId)
        );     
        var res = await api.deleteplanner("tripplannerid="+(id));            
        console.log(res.result);
    }
    const handleplannerlocation =(value:any)=>{   
       var res =value.split(",");     
       var splitval = res.map((x:any) => x.split("/"));
       //var splitvallocation = splitval.map((x:any) => x.split("#"));
       const doubled = splitval.map((x:any,index:any) =>x);
       return doubled;
    }
    let getplanners = async(value:any) => {
        try {
          
           var res = await api.getSharedplanners("Tripid="+(value));            
           console.log(res.result);
        }
        catch (error) {
            //console.log(error); 
        }
    }
    return (
        <div style={{ ...style, opacity, marginTop: 20,borderRight: '1px solid #DDDDDD' }} data-handler-id={handlerId}>
            <div role="Handle" ref={drag}>
                <div className={parentClasses.card}>
                    <div  ref={ref}  className={`${parentClasses.dragColumn} ${(planner.sharing=="1") ? "sharedBy" : ""}`}>
                        <CloseIcon
                            className={parentClasses.closeIcon}
                            onClick={e =>deletePlanner(planner.tripPlannerId)}
                        />
                        <MenuIcon className={parentClasses.haburgerIcon} />
                    </div>
                    <div className={parentClasses.dataColumn}>                 
                    <PlannerTextFieldPlannername
                            parentClasses={parentClasses}
                            setValue={(newValue: string) => updatePlanner('plannerName', newValue)}
                            value={planner.plannerName ?? ''}
                            labelText="Name"
                            description={planner.plannerName}
                            sharingrole={planner.sharedPlannerId??''}
                            Placeholder ={planner.plannerNamePlaceholder??''}
                        />
                   
                        <PlannerField
                            parentClasses={parentClasses}
                            setValue={(newValue: string) => updatePlanner('schedulingLeadTtime', newValue)}
                            value={planner.schedulingLeadTtime ?? ''}
                            labelText="Scheduling Lead time"
                            description={tooltips.schedulingLeadTtime}
                            readonly={planner.sharedPlannerId?true:false}
                        />
                        <PlannerSelect
                            parentClasses={parentClasses}
                            listValues={getAttendantSeatOptions()}
                            setValue={(newValue: string) => updatePlanner('noOfPatientSeats', newValue)}
                            value={planner.noOfPatientSeats ?? ''}
                            labelText="Attendant Seats"
                            description={tooltips.noOfPatientSeats}
                            readonly={planner.sharedPlannerId?true:false}
                        />
                        <PlannerSelect
                            parentClasses={parentClasses}
                            listValues={getStretcherOptions()}
                            setValue={(newValue: string) => updatePlanner('noOfStretchers', newValue)}
                            value={planner.noOfStretchers ?? ''}
                            labelText="Stretchers"
                            description={tooltips.noOfStretchers}
                            readonly={planner.sharedPlannerId?true:false}
                        />
                        <PlannerMultipleSelect
                            parentClasses={parentClasses}
                            listValues={getAcuityOptions()}
                            setValue={(newValue: string) => updatePlanner('maxPatientAcuity', newValue)}
                            value={planner.maxPatientAcuity ?? ''}
                            labelText="Acuity"
                            description={tooltips.maxPatientAcuity}
                            readonly={planner.sharedPlannerId?true:false}
                        />
                        <PlannerSelect
                            parentClasses={parentClasses}
                            listValues={getMultiloadAllowedOptions()}
                            setValue={(newValue: string) => updatePlanner('isMutliloadAllowed', newValue === 'Yes')}
                            value={planner.isMutliloadAllowed ? 'Yes' : 'No'}
                            labelText="Multiload Allowed?"
                            description={tooltips.isMutliloadAllowed}
                            readonly={planner.sharedPlannerId?true:false}
                        />
                        <PlannerSelect
                            parentClasses={parentClasses}
                            listValues={getServicedByOptions()}
                            setValue={(newValue: string) => updatePlanner('servicedBy', newValue)}
                            value={planner.servicedBy ?? "1"}
                            labelText="Serviced By"
                            description={tooltips.servicedBy}
                            readonly={planner.sharedPlannerId?true:false}
                        />
                        <PlannerSelect
                            parentClasses={parentClasses}
                            listValues={getMultiloadCapabilityOptions()}
                            setValue={(newValue: string) => updatePlanner('noOfPickupDropoffs', newValue)}
                            value={planner.noOfPickupDropoffs ?? ''}
                            labelText="Parallel Pickups/Dropoffs"
                            description={tooltips.noOfPickupDropoffs}
                            lastElement={true}
                            readonly={planner.sharedPlannerId?true:false}
                        />       
                          <PlannerSelect
                            parentClasses={parentClasses}
                            listValues={getPricingByOptions()}
                            setValue={(newValue: string) => updatePlanner('pricing', newValue)}
                            value={planner.pricing ?? ''}
                            labelText="Pricing"
                            description={tooltips.pricing}
                            lastElement={true}
                            readonly={planner.sharedPlannerId?true:false}
                        />                              
                        {
                            planner.sharingRole!=null?
                            <PlannerSelect
                            parentClasses={parentClasses}
                            listValues={getsharingroleOptions()}
                            setValue={(newValue: string) => updatePlanner('sharingRole', newValue)}
                            value={planner.sharingRole ??''}
                            labelText="Sharing Role"
                            description={""}
                            readonly={false}
                        />
                        //     <PlannerTextField
                        //     parentClasses={parentClasses}
                        //     setValue={(newValue: string) => updatePlanner('SharingRole', newValue)}
                        //     value={planner.sharingRole ?? ''}
                        //     labelText="Sharing Role"
                        //     description={""}
                        //     readonly={planner.sharedPlannerId?true:false}
                        // />
                           
                        :null
                        }
                        <PlannerShiftHours
                            parentClasses={parentClasses}
                            setValue={(newValue: string) => updatePlanner('shiftHours', newValue)}
                            value={''}
                            planner={planner}
                            labelText="Shift hours"
                            description={""}
                            readonly={planner.sharedPlannerId?true:false}
                            planners={planners}
                            setPlanners={setPlanners}
                            index={index}
                        />
                        {
                            planner.sharing=="1"?
                            <PlannerLinkFeildBy
                            parentClasses={parentClasses}                    
                            setValue={(newValue: string) => updatePlanner('noOfPickupDropoffs', newValue)}
                            value={planner.sharedlocation ?? ''}
                            labelText=""
                            description={tooltips.noOfPickupDropoffs}
                            lastElement={true}
                            />
                           
                        :
                        planner.sharing=="2"?
                        <PlannerLinkFeild
                            parentClasses={parentClasses}                    
                            setValue={(newValue: string) => updatePlanner('noOfPickupDropoffs', newValue)}
                            value={handleplannerlocation(planner.sharedlocation) ?? ''}                          
                            labelText=""
                            description={tooltips.noOfPickupDropoffs}
                            lastElement={true}
                            newval={sharedlocation}
                        />
                            :<div className={parentClasses.topBorder}></div>
                        }                       
                    </div>
                </div>
            </div>
        </div>
    );
}
export default PlannerCard;